var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#service_svg__clip0_3925_34574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2h5.333v5.333H2V2zm0 6.667h5.333V14H2V8.667zM8.667 2H14v5.333H8.667V2zm0 6.667H14V14H8.667V8.667zM10 3.333V6h2.667V3.333H10zM10 10v2.667h2.667V10H10zM3.333 3.333V6H6V3.333H3.333zm0 6.667v2.667H6V10H3.333z",
    fill: "#58657C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "service_svg__clip0_3925_34574"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgService;